import React from "react";
import { Button } from 'react-bootstrap';

import UtilService from '../../../../services/util';

function HeaderDetailTarefas(props) {
    const { timesheet, display } = props;
    return (
        <div style={{ marginTop: 30 }}>
            <h4>
                Tarefas &nbsp;

                {
                    timesheet.length > 0 &&
                    <Button className={display} onClick={
                            () => {
                                
                                const data = timesheet.map(item => ({ epico: item.epico, issue: `${item.issueKey} - ${item.issueSummary}`, author: item.author, timeLogged: parseFloat(String(item.timeLogged).replace(',', '.')), valor: item.valor || 0 }));
                                const header = [['Épico', 'Issue', 'Colaborador', 'Horas', 'Valor']];
                                const label= 'Tarefas';

                                UtilService.exportXls(data, label, header)
                            }
                        }
                    >
                        Exportar
                    </Button>
                }
            </h4>
        </div>
    );
}

export default HeaderDetailTarefas;
